import { t as __exportAll } from "./chunk-CfYAbeIz.mjs";
//#region src/vms/string-patterns.json
var string_patterns_default = {
	$schema: "http://json-schema.org/draft-07/schema#",
	$id: "http://locuslabs-vms.com/schemas/string-patterns.json",
	title: "String Patterns",
	definitions: {
		"align": {
			"type": "string",
			"enum": [
				"left",
				"center",
				"right"
			]
		},
		"categoryName": {
			"type": "string",
			"pattern": "^[a-z.]+$"
		},
		"color": {
			"type": "string",
			"pattern": "^#[0-9a-f]{6}$"
		},
		"dateTime": {
			"type": "string",
			"format": "date-time"
		},
		"entityId": {
			"type": "string",
			"pattern": "^[0-9]+$"
		},
		"featureId": {
			"type": "string",
			"pattern": "^[0-9]+[a-z]$"
		},
		"hours": { "anyOf": [
			{ "$ref": "#/definitions/hoursOneDay" },
			{ "$ref": "#/definitions/hoursDayRange" },
			{ "$ref": "#/definitions/hoursDayRangeAndDay" },
			{ "$ref": "#/definitions/hoursDayRangeAndDayRange" },
			{ "$ref": "#/definitions/hoursDayRangeAndDayAndDay" }
		] },
		"hoursOneDay": {
			"type": "string",
			"pattern": "^ *(Mo|Tu|We|Th|Fr|Sa|Su) *[0-2][0-9]:[0-5][0-9]-[0-2][0-9]:[0-5][0-9] *$"
		},
		"hoursDayRange": {
			"type": "string",
			"pattern": "^ *(Mo|Tu|We|Th|Fr|Sa|Su)-(Mo|Tu|We|Th|Fr|Sa|Su) *[0-2][0-9]:[0-5][0-9]-[0-2][0-9]:[0-5][0-9] *$"
		},
		"hoursDayRangeAndDay": {
			"type": "string",
			"pattern": "^ *(Mo|Tu|We|Th|Fr|Sa|Su)-(Mo|Tu|We|Th|Fr|Sa|Su) *[0-2][0-9]:[0-5][0-9]-[0-2][0-9]:[0-5][0-9]; *(Mo|Tu|We|Th|Fr|Sa|Su) *[0-2][0-9]:[0-5][0-9]-[0-2][0-9]:[0-5][0-9] *$"
		},
		"hoursDayRangeAndDayRange": {
			"type": "string",
			"pattern": "^ *(Mo|Tu|We|Th|Fr|Sa|Su)-(Mo|Tu|We|Th|Fr|Sa|Su) *[0-2][0-9]:[0-5][0-9]-[0-2][0-9]:[0-5][0-9]; *(Mo|Tu|We|Th|Fr|Sa|Su)-(Mo|Tu|We|Th|Fr|Sa|Su) *[0-2][0-9]:[0-5][0-9]-[0-2][0-9]:[0-5][0-9] *$"
		},
		"hoursDayRangeAndDayAndDay": {
			"type": "string",
			"pattern": "^ *(Mo|Tu|We|Th|Fr|Sa|Su)-(Mo|Tu|We|Th|Fr|Sa|Su) *[0-2][0-9]:[0-5][0-9]-[0-2][0-9]:[0-5][0-9]; *(Mo|Tu|We|Th|Fr|Sa|Su) *[0-2][0-9]:[0-5][0-9]-[0-2][0-9]:[0-5][0-9]; *(Mo|Tu|We|Th|Fr|Sa|Su) *[0-2][0-9]:[0-5][0-9]-[0-2][0-9]:[0-5][0-9] *$"
		},
		"levelId": { "oneOf": [{
			"type": "string",
			"pattern": "^[a-z0-9:]+-[a-zA-Z0-9:]+-[a-zA-Z0-9:]+$"
		}, {
			"type": "string",
			"pattern": "^VENUEID-[a-zA-Z0-9:]+-[a-zA-Z0-9:]+$"
		}] },
		"numberString": {
			"type": "string",
			"pattern": "^[-+]?(?:\\d*\\.\\d+|\\d+\\.?)$"
		},
		"ordinalId": {
			"type": "string",
			"pattern": "^ordinal: -*[0-9]+$"
		},
		"strokeAlign": {
			"type": "string",
			"enum": [
				"inside",
				"center",
				"outside"
			]
		},
		"structureId": { "oneOf": [{
			"type": "string",
			"pattern": "^[a-z0-9:]+-[a-zA-Z0-9:]+$"
		}, {
			"type": "string",
			"pattern": "^VENUEID-[a-zA-Z0-9:]+$"
		}] },
		"subid": {
			"type": "string",
			"pattern": "^[0-9]+[a-z]$"
		},
		"utmZone": {
			"type": "string",
			"pattern": "[0-9]{2}s?"
		},
		"uuid": {
			"type": "string",
			"pattern": "[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
		},
		"venueId": { "oneOf": [{
			"type": "string",
			"pattern": "^[a-z0-9:]+$"
		}, {
			"type": "string",
			"pattern": "^VENUEID$"
		}] },
		"version": {
			"type": "string",
			"pattern": "20[0-9]{2}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}$"
		},
		"vmsUuid": {
			"type": "string",
			"pattern": "^[a-zA-Z0-9]+_[0-9]+$"
		}
	}
};
//#endregion
//#region src/vms/latlng.json
var latlng_default = {
	$schema: "http://json-schema.org/draft-07/schema#",
	$id: "http://locuslabs-vms.com/schemas/latlng.json",
	type: "object",
	title: "LatLng",
	properties: {
		"lat": {
			"type": "number",
			"minimum": -90,
			"maximum": 90
		},
		"lng": {
			"type": "number",
			"minimum": -180,
			"maximum": 180
		}
	},
	required: ["lat", "lng"],
	constructorParameterOrder: ["lat", "lng"],
	additionalProperties: false
};
//#endregion
//#region src/vms/latlng-array.json
var latlng_array_default = {
	$schema: "http://json-schema.org/draft-07/schema#",
	$id: "http://locuslabs-vms.com/schemas/latlng-array.json",
	title: "LatLng Array",
	type: "array",
	items: {
		"type": "number",
		"minimum": -180,
		"maximum": 180
	},
	minItems: 2,
	maxItems: 2
};
//#endregion
//#region src/vms/bounding-box.json
var bounding_box_default = {
	$schema: "http://json-schema.org/draft-07/schema#",
	$id: "http://locuslabs-vms.com/schemas/bounding-box.json",
	type: "object",
	title: "Bounding Box",
	properties: {
		"n": {
			"type": "number",
			"minimum": -90,
			"maximum": 90
		},
		"e": {
			"type": "number",
			"minimum": -180,
			"maximum": 180
		},
		"s": {
			"type": "number",
			"minimum": -90,
			"maximum": 90
		},
		"w": {
			"type": "number",
			"minimum": -180,
			"maximum": 180
		}
	},
	required: [
		"n",
		"e",
		"s",
		"w"
	],
	constructorParameterOrder: [
		"n",
		"e",
		"s",
		"w"
	],
	additionalProperties: false
};
//#endregion
//#region src/vms/bounds-polygon.json
var bounds_polygon_default = {
	$schema: "http://json-schema.org/draft-07/schema#",
	$id: "http://locuslabs-vms.com/schemas/bounds-polygon.json",
	type: "array",
	title: "Bounds Polygon",
	items: { "$ref": "latlng-array.json" }
};
//#endregion
//#region src/vms/level.json
var level_default = {
	$schema: "http://json-schema.org/draft-07/schema#",
	$id: "http://locuslabs-vms.com/schemas/level.json",
	type: "object",
	title: "Level",
	properties: {
		"venueId": { "$ref": "string-patterns.json#/definitions/venueId" },
		"structureId": { "$ref": "string-patterns.json#/definitions/structureId" },
		"ordinalId": { "$ref": "string-patterns.json#/definitions/ordinalId" },
		"id": { "$ref": "string-patterns.json#/definitions/levelId" },
		"name": { "type": "string" },
		"isDefaultForStructure": { "type": "boolean" },
		"details": { "type": "string" },
		"boundingBox": { "$ref": "bounding-box.json" },
		"clFloor": { "type": "number" }
	},
	required: [
		"venueId",
		"structureId",
		"ordinalId",
		"id",
		"name",
		"details",
		"isDefaultForStructure",
		"boundingBox"
	],
	constructorParameterOrder: [
		"venueId",
		"structureId",
		"ordinalId",
		"id",
		"name",
		"details",
		"isDefaultForStructure",
		"boundingBox",
		"clFloor"
	],
	additionalProperties: false
};
//#endregion
//#region src/vms/ordinal.json
var ordinal_default = {
	$schema: "http://json-schema.org/draft-07/schema#",
	$id: "http://locuslabs-vms.com/schemas/ordinal.json",
	type: "object",
	title: "Ordinal",
	properties: {
		"venueId": { "$ref": "string-patterns.json#/definitions/venueId" },
		"id": { "$ref": "string-patterns.json#/definitions/ordinalId" },
		"ordinalNumber": { "type": "number" },
		"isDefaultForVenue": { "type": "boolean" }
	},
	required: [
		"venueId",
		"id",
		"ordinalNumber",
		"isDefaultForVenue"
	],
	constructorParameterOrder: [
		"venueId",
		"id",
		"ordinalNumber",
		"isDefaultForVenue"
	],
	additionalProperties: false
};
//#endregion
//#region src/vms/structure.json
var structure_default = {
	$schema: "http://json-schema.org/draft-07/schema#",
	$id: "http://locuslabs-vms.com/schemas/structure.json",
	type: "object",
	title: "Structure",
	properties: {
		"id": { "$ref": "string-patterns.json#/definitions/structureId" },
		"name": { "type": "string" },
		"shouldDisplay": { "type": "boolean" },
		"isDefaultForVenue": { "type": "boolean" },
		"venueId": { "$ref": "string-patterns.json#/definitions/venueId" },
		"boundingBox": { "$ref": "bounding-box.json" }
	},
	required: [
		"id",
		"name",
		"shouldDisplay",
		"isDefaultForVenue",
		"venueId",
		"boundingBox"
	],
	constructorParameterOrder: [
		"venueId",
		"id",
		"name",
		"shouldDisplay",
		"isDefaultForVenue",
		"boundingBox"
	],
	additionalProperties: false
};
//#endregion
//#region src/vms/venue.json
var venue_default = {
	$schema: "http://json-schema.org/draft-07/schema#",
	$id: "http://locuslabs-vms.com/schemas/venue.json",
	type: "object",
	title: "Venue",
	properties: {
		"assetFormatVersion": { "type": "string" },
		"boundingBox": { "$ref": "bounding-box.json" },
		"id": { "$ref": "string-patterns.json#/definitions/venueId" },
		"name": { "type": "string" },
		"venueCategory": { "type": "string" },
		"venueCenter": { "$ref": "latlng-array.json" }
	},
	required: [
		"assetFormatVersion",
		"boundingBox",
		"id",
		"name",
		"venueCategory",
		"venueCenter"
	],
	constructorParameterOrder: [
		"assetFormatVersion",
		"boundingBox",
		"id",
		"name",
		"venueCategory",
		"venueCenter"
	],
	additionalProperties: false
};
//#endregion
//#region src/vms/venue-summary.json
var venue_summary_default = {
	$schema: "http://json-schema.org/draft-07/schema#",
	$id: "http://locuslabs-vms.com/schemas/venue-summary.json",
	type: "object",
	title: "Venue Summary",
	properties: {
		"code": { "type": "string" },
		"id": { "$ref": "string-patterns.json#/definitions/venueId" },
		"name": { "type": "string" },
		"locale": { "type": "string" }
	},
	required: [
		"code",
		"id",
		"name",
		"locale"
	],
	constructorParameterOrder: [
		"code",
		"id",
		"name",
		"locale"
	],
	additionalProperties: false
};
//#endregion
//#region src/vms/map-note-comment.json
var map_note_comment_default = {
	$schema: "http://json-schema.org/draft-07/schema#",
	definitions: {
		"item": {
			"type": "object",
			"oneOf": [{ "$ref": "#/definitions/comment" }, { "$ref": "#/definitions/history" }]
		},
		"comment": {
			"type": "object",
			"properties": {
				"id": {
					"type": "number",
					"minimum": 0
				},
				"type": {
					"type": "string",
					"enum": ["comment"]
				},
				"uploads": {
					"type": "array",
					"items": {
						"type": "string",
						"format": "uri"
					}
				},
				"body": { "type": "string" },
				"createdAt": { "$ref": "string-patterns.json#/definitions/dateTime" },
				"createdBy": { "$ref": "#/definitions/createdBy" }
			},
			"required": [
				"id",
				"type",
				"createdAt",
				"createdBy"
			],
			"additionalProperties": false
		},
		"history": {
			"type": "object",
			"properties": {
				"type": {
					"type": "string",
					"enum": ["history"]
				},
				"createdAt": { "$ref": "string-patterns.json#/definitions/dateTime" },
				"fieldName": {
					"type": "string",
					"enum": [
						"subject",
						"noteType",
						"noteStatus",
						"latitude",
						"longitude"
					]
				},
				"previousValue": { "oneOf": [
					{ "type": "string" },
					{ "type": "number" },
					{ "type": "object" }
				] },
				"newValue": { "oneOf": [
					{ "type": "string" },
					{ "type": "number" },
					{ "type": "object" }
				] }
			},
			"required": [
				"type",
				"createdAt",
				"newValue",
				"previousValue",
				"fieldName"
			],
			"additionalProperties": false
		},
		"createdBy": {
			"type": "object",
			"properties": { "email": {
				"type": "string",
				"format": "email"
			} },
			"required": ["email"],
			"additionalProperties": false
		}
	},
	$id: "http://locuslabs-vms.com/schemas/map-note-comment.json",
	title: "Map Note Comment",
	$ref: "#/definitions/item",
	additionalFields: false
};
//#endregion
//#region src/vms/map-note-filter.json
var map_note_filter_default = {
	$schema: "http://json-schema.org/draft-07/schema#",
	definitions: { "type": {
		"type": "object",
		"properties": {
			"noType": { "type": "boolean" },
			"mapRequest": { "type": "boolean" },
			"fieldVerify": { "type": "boolean" }
		},
		"required": [
			"noType",
			"mapRequest",
			"fieldVerify"
		],
		"additionalFields": false
	} },
	$id: "http://locuslabs-vms.com/schemas/map-note-filter.json",
	title: "Map Note Filter",
	type: "object",
	properties: {
		"status": {
			"type": "string",
			"enum": [
				"open",
				"resolved",
				"all"
			]
		},
		"type": { "$ref": "#/definitions/type" }
	},
	required: ["status", "type"],
	additionalFields: false
};
//#endregion
//#region src/vms/map-note.json
var map_note_default = {
	$schema: "http://json-schema.org/draft-07/schema#",
	definitions: { "location": {
		"type": "object",
		"properties": {
			"venueId": { "$ref": "string-patterns.json#/definitions/venueId" },
			"ordinalId": { "$ref": "string-patterns.json#/definitions/ordinalId" },
			"latitude": { "type": "number" },
			"longitude": { "type": "number" },
			"levelId": { "$ref": "string-patterns.json#/definitions/levelId" },
			"structureId": { "$ref": "string-patterns.json#/definitions/structureId" }
		},
		"required": [
			"venueId",
			"ordinalId",
			"latitude",
			"longitude"
		],
		"additionalFields": false
	} },
	$id: "http://locuslabs-vms.com/schemas/map-note.json",
	title: "Map Note",
	type: "object",
	properties: {
		"subject": {
			"type": "string",
			"minLength": 1
		},
		"noteStatus": {
			"type": "string",
			"enum": ["open", "resolved"]
		},
		"description": { "type": "string" },
		"noteType": {
			"type": "string",
			"enum": [
				"noType",
				"fieldVerify",
				"mapRequest"
			]
		},
		"location": { "$ref": "#/definitions/location" }
	},
	required: [
		"subject",
		"noteStatus",
		"description",
		"noteType",
		"location"
	],
	additionalFields: false
};
//#endregion
//#region src/vms/wayfinding-segment.json
var wayfinding_segment_default = {
	$schema: "http://json-schema.org/draft-07/schema#",
	$id: "http://locuslabs-vms.com/schemas/wayfindingSegment.json",
	type: "object",
	title: "Wayfinding Segment",
	definitions: {
		"lng": {
			"type": "number",
			"minimum": -180,
			"maximum": 180
		},
		"lat": {
			"type": "number",
			"minimum": -90,
			"maximum": 90
		},
		"segmentType": {
			"type": "string",
			"enum": [
				"walk",
				"security",
				"escalator"
			]
		},
		"lngLatArray": {
			"type": "array",
			"items": [{ "$ref": "#/definitions/lng" }, { "$ref": "#/definitions/lat" }]
		},
		"lineString": {
			"type": "array",
			"items": { "$ref": "#/definitions/lngLatArray" }
		},
		"badge": {
			"type": "object",
			"properties": {
				"entityId": { "$ref": "string-patterns.json#/definitions/entityId" },
				"canonicalName": { "$ref": "string-patterns.json#/definitions/categoryName" },
				"coordinates": { "$ref": "#/definitions/lngLatArray" }
			},
			"required": [
				"entityId",
				"canonicalName",
				"coordinates"
			],
			"additionalProperties": false
		}
	},
	properties: {
		"levelId": { "$ref": "string-patterns.json#/definitions/levelId" },
		"ordinalId": { "$ref": "string-patterns.json#/definitions/ordinalId" },
		"venueId": { "$ref": "string-patterns.json#/definitions/venueId" },
		"coordinates": { "$ref": "#/definitions/lineString" },
		"segmentType": { "$ref": "#/definitions/segmentType" },
		"badges": {
			"type": "array",
			"items": { "$ref": "#/definitions/badge" }
		}
	},
	required: [
		"levelId",
		"ordinalId",
		"venueId",
		"segmentType",
		"coordinates"
	],
	additionalProperties: false
};
//#endregion
//#region src/vms/index.js
var vms_exports = /* @__PURE__ */ __exportAll({
	BoundingBox: () => bounding_box_default,
	BoundsPolygon: () => bounds_polygon_default,
	LatLng: () => latlng_default,
	LatLngArray: () => latlng_array_default,
	Level: () => level_default,
	MapNote: () => map_note_default,
	MapNoteComment: () => map_note_comment_default,
	MapNoteFilter: () => map_note_filter_default,
	Ordinal: () => ordinal_default,
	StringPatterns: () => string_patterns_default,
	Structure: () => structure_default,
	Venue: () => venue_default,
	VenueSummary: () => venue_summary_default,
	WayfindingSegment: () => wayfinding_segment_default
});
//#endregion
export { map_note_comment_default as a, structure_default as c, bounds_polygon_default as d, bounding_box_default as f, string_patterns_default as h, map_note_filter_default as i, ordinal_default as l, latlng_default as m, wayfinding_segment_default as n, venue_summary_default as o, latlng_array_default as p, map_note_default as r, venue_default as s, vms_exports as t, level_default as u };
